import gql from 'graphql-tag';

export default gql`
  query callRecording($path: String!) {
    callRecording(path: $path)
  }
`;
